import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  controllerCode: "",
  customerScope: "",
  language: "",
  cocoConfig: {},
  cocoConfigLabel: {},
};

const cocoConfigSlice = createSlice({
  name: "CocoConfig",
  initialState,
  reducers: {
    addControllerCode: (state, action) => {
      state.controllerCode = action.payload;
    },
    addCustomerScope: (state, action) => {
      state.customerScope = action.payload;
    },
    addLanguage: (state, action) => {
      state.language = action.payload;
    },
    addCocoConfigLabel: (state, action) => {
      state.cocoConfigLabel = action.payload;
    },
    addCocoConfig: (state, action) => {
      state.cocoConfig = action.payload;
    },
  },
});

export const {
  addControllerCode,
  addCustomerScope,
  addLanguage,
  addCocoConfigLabel,
  addCocoConfig,
} = cocoConfigSlice.actions;
export default cocoConfigSlice.reducer;
